import React from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthImaage from "../../assets/images/authbanner.png";
import { useForm, SubmitHandler } from "react-hook-form";
import { AuthModal, ButtonLarge, emailValidator, FormHookInput, Loader } from "@thdinc/hpf-shared";
import { useAppDispatch, useAppSelector } from "@/hooks/hook";
import { loginUser } from "@/redux/slices/userSlice";
import useError from "@/hooks/useError ";
import FormPasswordInput from "@/components/formHookInput/formPasswordInput";
import useLoading from "@/hooks/useLoading";
import { formStateChange } from "@/redux/slices/formSlice";
import { fetchBillingInfo } from "@/redux/slices/billingInfoSlice";

export const Login = () => {
  const { isLoading, startLoading, stopLoading } = useLoading();

  const [error, setCustomError] = useError()
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  type Inputs = {
    email: string;
    password: string;
  };
  const {
    register,
    handleSubmit,

    formState: { errors },
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      dispatch(formStateChange(false));

      startLoading()
      const res = await dispatch(loginUser(data)).unwrap();
      console.log('res', res);
      if (res?.success === true) {
        res?.user.card_status && dispatch(fetchBillingInfo({ refreshToken: res.refreshToken, businessId: res.user.business_id }))
        const eventId = localStorage.getItem('eventId')
        // navigate to dashboard page
        if (eventId) {
          navigate(`/events?tab=Upcoming&id=${eventId}`)
        }
        else if (res?.user?.futurePayment && !res?.user?.card_status) {
          navigate("/billing");
        } else {
          navigate("/events?tab=Upcoming");
        }
      }
      else if (res?.success === false) {
        setCustomError('login', res?.message)
      }
      // Alert({ message: "Login successfully", type: "success" });
    } catch (error) {
      console.log('error')
      setCustomError('login', "Incorrect email or password")
      stopLoading()
      // Alert({ message: "Incorrect email or password", type: "error" });
    }
  };

  return (
    <div className="container mx-auto h-screen relative">
      <div className="flex flex-col justify-center    min-h-full ">
        <div className="flex justify-center">
          <img
            className="w-[500px] hidden lg:block rounded-3xl"
            src={AuthImaage}
            alt=""
          />
          <div className="flex flex-col justify-center lg:-ml-11">
            <AuthModal>
              <div className="text-center">
                <p className="text-2xl font-bold ">Login</p>
                <p className=" mt-6">
                  Welcome back! Enter your email and password to login.
                </p>
              </div>
              <form
                className="mt-8 space-y-6"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="rounded-md shadow-sm -space-y-px">
                  <div className=" font-semibold my-2">Email</div>
                  <FormHookInput
                    type="email"
                    placeholder="Email"
                    register={register("email", {
                      required: "Email is required!",
                      pattern: emailValidator,
                    })}
                    error={errors.email}
                  />
                  <div className="mt-8">
                    <div className=" font-semibold my-2">Password</div>
                    <FormPasswordInput
                      type="password"
                      placeholder="Password"
                      register={register("password", {
                        required: "Password is required",
                      })}
                      error={errors.password}
                    />
                  </div>

                </div>
                {error?.name === 'login' && <p className="text-primary-red text-center mt-">{error.message}</p>}

                <div className="">

                  <ButtonLarge classes="min-w-full" disabled={isLoading} type="submit">
                    {isLoading ? <Loader color="bg-gray-50"  /> : "Login"}
                  </ButtonLarge>
                </div>
              </form>
              {/* <div className="text-center mt-4">
                <Link to="/signup" className="text-primary-red  ">
                  Signup
                </Link>
              </div> */}
              <div className="text-center mt-4">
                <Link to="/forget/password" className="text-primary-red  ">
                  Forgot password?
                </Link>
              </div>
            </AuthModal>
          </div>
        </div>
      </div>
    </div>
  );
};
